import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'input-select',
  templateUrl: './input-select.component.html',
  styleUrls: ['./input-select.component.scss', '../input.scss']
})
export class InputSelectComponent {
  
  @Input() 
  public label: string = "Test";

  @Input()
  public options: string[] = []

  @Input()
  public inputValue: string = "";

  @Output()
  public save = new EventEmitter();

  i=0;

  constructor() {
    console.log(this.inputValue)
  }

  emit(value: string) {
    this.inputValue = value;
    this.save.emit(this.inputValue);
  }

  openSelectDialog(label, inputValue, options) {

  }
}
